import { render } from "./AsTextarea.vue?vue&type=template&id=6aadd3ca&ts=true"
import script from "./AsTextarea.vue?vue&type=script&lang=ts"
export * from "./AsTextarea.vue?vue&type=script&lang=ts"

import "./AsTextarea.vue?vue&type=style&index=0&id=6aadd3ca&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__